export const WHATSAPP_NUMBER = "5531933004813";

export const CHALES = [
    {
        id: "lua-cheia",
        capitulo: "01",
        nome: "Chalé Lua Cheia",
        diaria: 1050,
        tagline: "Noites banhadas pelo brilho da lua sobre a serra.",
        descricao:
            "Um refúgio pensado para dois: cama king, hidromassagem e piscina spa aquecida com vista aberta para a Serra da Moeda. Aqui, o tempo desacelera.",
        fotos: Array.from({ length: 20 }, (_, i) => `/images/lua/lua-${String(i + 1).padStart(2, "0")}.jpg`),
        features: [
            { icon: "BedDouble", label: "Cama king" },
            { icon: "Bath", label: "Hidromassagem" },
            { icon: "ShowerHead", label: "Banho duplo a gás" },
            { icon: "Snowflake", label: "Ar-condicionado" },
            { icon: "Wifi", label: "Wi-Fi e TV" },
            { icon: "CookingPot", label: "Cozinha completa" },
            { icon: "Waves", label: "Piscina spa aquecida" },
            { icon: "Flame", label: "Churrasqueira" },
            { icon: "Mountain", label: "Vista da Serra" },
        ],
    },
    {
        id: "por-do-sol",
        capitulo: "02",
        nome: "Chalé Pôr do Sol",
        diaria: 1180,
        tagline: "O espetáculo dourado do entardecer, só para vocês.",
        descricao:
            "Tudo do Lua Cheia, com algo a mais: rede suspensa para tardes lentas e uma cascata particular que embala o descanso com o som da água.",
        fotos: [
            "01", "02", "03", "04", "05", "06", "07", "09", "10", "11",
            "12", "13", "14", "15", "16", "17", "18", "19", "20",
        ].map((n) => `/images/porsol/sol-${n}.jpg`),
        features: [
            { icon: "BedDouble", label: "Cama king" },
            { icon: "Bath", label: "Hidromassagem" },
            { icon: "ShowerHead", label: "Banho duplo a gás" },
            { icon: "Snowflake", label: "Ar-condicionado" },
            { icon: "Wifi", label: "Wi-Fi e TV" },
            { icon: "CookingPot", label: "Cozinha completa" },
            { icon: "Waves", label: "Piscina spa aquecida" },
            { icon: "Flame", label: "Churrasqueira" },
            { icon: "Mountain", label: "Vista da Serra" },
            { icon: "Sofa", label: "Rede suspensa" },
            { icon: "Droplets", label: "Cascata" },
        ],
    },
];

export const DECORACOES = [
    {
        id: "nenhuma",
        nome: "Sem decoração",
        valor: 0,
        ideal: null,
        itens: [],
    },
    {
        id: "basica",
        nome: "Básica",
        valor: 350,
        ideal: "Ideal para surpresas simples e delicadas",
        itens: [
            "Pétalas de rosas sobre a cama",
            "Velas aromáticas decorativas",
            "Balões em formato de coração",
            "Frutas e chocolates finos",
        ],
    },
    {
        id: "premium",
        nome: "Premium",
        valor: 480,
        ideal: "Perfeito para aniversários de namoro ou pedidos especiais",
        itens: [
            "Cama decorada com pétalas em formato de coração",
            "Balões no teto com fitas vermelhas",
            "Velas aromáticas + luminárias LED",
            "Bandeja com espumante, taças e morangos",
            "Música ambiente personalizada",
        ],
    },
    {
        id: "luxo",
        nome: "Luxo",
        valor: 650,
        ideal: "Ideal para noites de núpcias ou datas marcantes",
        itens: [
            "Caminho de pétalas até o quarto",
            "Cama com iniciais do casal em pétalas",
            "Balões metalizados + cortina de coração",
            "Velas aromáticas + iluminação romântica",
            "Espumante, taças, frutas e fondue de chocolate",
            "Toalhas dobradas em formato de cisnes",
        ],
    },
];

export const PET_FEE = 200;

export const FAQ_ITEMS = [
    {
        q: "Posso levar meu pet?",
        a: "Sim! Somos pet friendly. Cobramos uma taxa de R$ 200,00 para higienização do espaço após a hospedagem com animais de estimação.",
    },
    {
        q: "Algo incluso na acomodação?",
        a: "Sim! Café da manhã e jantar estão inclusos na acomodação.",
    },
    {
        q: "Onde fica localizado?",
        a: "O Chalés Boutique da Serra fica na região de Moeda, Minas Gerais — Estrada Sentido Marinho da Serra, Moeda, MG, 35470-000.",
    },
    {
        q: "Qual o horário de check-in?",
        a: "Check-in a partir das 12:00 horas.",
    },
    {
        q: "Qual o horário de check-out?",
        a: "Check-out até as 16:00 horas.",
    },
];

export const brl = (v) =>
    v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
